import * as React from 'react'
import * as ReactTooltip from 'react-tooltip'
import BlogPost from '../components/BlogPost'
import Header from '../components/Header'
import Helmet from 'react-helmet'
import MailingListModal from '../components/MailingListModal'
import './Blog.scss'

interface IBlogPageProps {
  data: {
    allMarkdownRemark: {
      edges: Array<{
        node: {
          id: string
          html: string
          frontmatter: {
            date: string
            path: string
            title: string
            author: string
          }
        }
      }>
    }
  }
}

const BlogPage = (props: IBlogPageProps) => {
  const posts = props.data.allMarkdownRemark.edges.map(node => node.node)

  return (
    <div className="page__blog__wrapper">
      <Helmet title="News" />
      <div className="page page__blog">
        <ReactTooltip className="tooltip" place="bottom" effect="solid" aria-haspopup="true" />
        <Header />
        <div className="blog__list">
          {posts.map(post => <BlogPost key={post.id} post={post} />)}
        </div>
        <MailingListModal />
      </div>
    </div>
  )
}

export default BlogPage

export const pageQuery = graphql`
  query BlogListQuery {
    allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
      edges {
        node {
          id
          html
          frontmatter {
            date
            path
            title
            author
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/blog.tsx